import type { FC } from 'react'
import { FaArrowRightLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Climate: FC = () => {
  const { t } = useTranslation();

  const parameters = [
    { name: t('climate_param_temperature'), desc: t('climate_param_temperature_desc') },
    { name: t('climate_param_humidity'), desc: t('climate_param_humidity_desc') },
    { name: t('climate_param_airflow'), desc: t('climate_param_airflow_desc') },
    { name: t('climate_param_co2'), desc: t('climate_param_co2_desc') },
    { name: t('climate_param_light'), desc: t('climate_param_light_desc') },
    { name: t('climate_param_water'), desc: t('climate_param_water_desc') },
    { name: t('climate_param_nutrient'), desc: t('climate_param_nutrient_desc') },
    { name: t('climate_param_monitoring'), desc: t('climate_param_monitoring_desc') },
  ]
  const navigate = useNavigate();

  return (
    <>
      <div className="bg-white min-h-screen text-[#1C4734]">



        {/* Hero — split layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 min-h-[520px]">
          {/* Left: dark */}
          <div className="bg-[#1C4734] text-white p-8 md:p-16 flex flex-col justify-between">
            <div>
              <h1 className="text-4xl md:text-5xl font-normal leading-[1.15] mb-8">
                {t("climate_hero_title")}
              </h1>
              <div className="w-55 h-px bg-white mb-8" />
              <p className="text-white text-base leading-relaxed max-w-sm">
                {t("climate_hero_subtitle")}
              </p>
            </div>

          </div>

          {/* Right: white */}
          <div className="p-8 md:p-16 flex flex-col justify-center border-l border-[#1C4734]/8">
            <h2 className="text-4xl font-semibold mb-6 leading-snug">
              {t("climate_section_title")}
            </h2>
            <p className="text-[#1C4734] text-base leading-relaxed mb-6">
              {t("climate_section_paragraph_1")}
            </p>
            <p className="text-[#1C4734] text-base leading-relaxed">
              {t("climate_section_paragraph_2")}
            </p>
          </div>
        </div>

        {/* Parameters section */}
        <div className="border-t border-[#1C4734]/10">
          <div className="px-3 py-12">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#1C4734]/18">
              {parameters.map((p, i) => (
                <div key={p.name} className="bg-white p-8 hover:bg-[#f4f8f6] transition-colors">
                  <p className="text-xs text-[#1C4734]/30 mb-3 font-sans">
                    {String(i + 1).padStart(2, '0')}
                  </p>
                  <p className="text-base font-normal mb-2">{p.name}</p>
                  <p className="text-xs text-[#1C4734] leading-relaxed">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Two feature blocks */}
        <div className="border-t border-[#1C4734]/10 grid grid-cols-1 md:grid-cols-2">
          <div className="p-8 md:p-16 border-r border-[#1C4734]/10">
            <h3 className="text-2xl font-normal mb-5">{t('climate_feature_intelligent_heading')}</h3>
            <div className="w-8 h-px bg-[#1C4734]/20 mb-5" />
            <p className="text-[#1C4734] text-sm leading-relaxed">
              {t('climate_feature_intelligent_text')}
            </p>
          </div>
          <div className="p-8 md:p-16 bg-[#f8faf9]">
            <h3 className="text-2xl font-normal mb-5">{t('climate_feature_accurate_heading')}</h3>
            <div className="w-8 h-px bg-[#1C4734]/20 mb-5" />
            <p className="text-[#1C4734] text-sm leading-relaxed">
              {t('climate_feature_accurate_text')}
            </p>
          </div>
        </div>

        {/* Closing quote */}
        <div className="bg-[#1C4734] px-8 md:px-24 py-20 text-center">
          <p className="text-white text-2xl md:text-3xl font-normal leading-relaxed max-w-3xl mx-auto">
            {t('climate_closing_quote')}
          </p>
        </div>
      </div>

      <section className="py-12 bg-white">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <button
            onClick={() => navigate("/contact")}
            className="w-full sm:w-auto group inline-flex justify-center items-center gap-3 px-8 py-4 rounded-lg bg-[#7FD655] text-white font-semibold text-base sm:text-lg hover:bg-[#002f37] cursor-pointer transition-all shadow-md"
          >
            {t("contact_us_button")}
            <FaArrowRightLong className="transition-transform group-hover:translate-x-2" />
          </button>
        </div>
      </section>
    </>
  )
}

export default Climate;